/**
 * Hook for managing mobile/tablet view mode preference (comfort vs compact)
 */
import { useLocalStorage } from './useLocalStorage';

export type ViewMode = 'comfort' | 'compact';

export const useViewMode = () => {
  return useLocalStorage<ViewMode>('mobileViewMode', 'compact');
};
